<template>
    <b-modal id="modal-changedata" centered class="modal-changedata">
      <div class="modal-changedata-itens">
        <button
          class="modal-changedata-itens-close"
          @click="$bvModal.hide('modal-changedata')"
        >
        <img src="@/assets/img/close.png" alt="close" width="30">
        </button>
      </div>
      <div class="modal-changedata-content">
        <h3>Alterar dados</h3>
        <form @submit.prevent="update()">
            <div class="row">
                <div class="col-md-6">
                    <input type="email" name="email" v-model="email" :placeholder="user?.email">
                </div>
                <div class="col-md-6">
                    <input type="text" name="name" v-model="name" :placeholder="user?.nome">
                </div>
            </div>
            <div class="content-input-check">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="acceptedcom" id="acceptedcom">
                    <label class="form-check-label" for="acceptedcom">
                      Consinto, de forma livre, consciente e informada, que a Manuel Rui Azinhais Nabeiro, Unipessoal, Lda. recolha e trate os dados pessoais por mim fornecidos para ações de marketing e publicidade, nos termos melhor descritos na <a href="https://www.cafedasorte.pt/storage/app/media/informacoeslegais/politicadeprivacidade.pdf" target="_blank">Política de Privacidade</a>
                    </label>
                </div>
            </div>
            <div class="content-input-button">
                <div class="btn btn-send">
                    <button type="submit">gravar</button>
                </div>
            </div>

        </form>
        
      </div>
    </b-modal>
  </template>
  
  <script>
import axios from 'axios';
import { mapGetters } from 'vuex';
  
  export default {
    data() {
      return {
        name: '',
        email: '',
        acceptedcom: false,
      };
    },
    computed: {
      ...mapGetters(['user'])
    },
    methods: {
      async update(){
        const data = {
          name: this.name,
          email: this.email,
          acceptedcom: this.acceptedcom,
          id: localStorage.getItem('token') || null,
        }
        await axios.post('/api/v1/user/update', data)
        .then((response) => {
          if(response.data.success === true){
            this.$swal.fire({
              icon: 'success',
              title: 'Sucesso',
              text: 'Dados alterados com sucesso!',
            })
            this.$bvModal.hide('modal-changedata');
            this.$store.dispatch('getUser');
          }else{
            this.$swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Ocorreu um erro ao alterar os dados!',
            })
          }
        }).catch((error) => {
          console.log(error);
          this.$swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: error?.error?.context?.payload?.email?.message || error?.error?.context?.payload?.telemovel?.message || 'Ocorreu um erro ao alterar os dados!',
          })
        });
      }
    },
    mounted() {
      this.name = this.user?.nome || '';
      this.email = this.user?.email || '';
      this.acceptedcom = this.user?.acceptedcom || false;
    }
  };
  </script>
  
  <style lang="scss" >
  #modal-changedata {
    .modal-header,
    .modal-footer {
      display: none;
    }
    .modal-dialog {
      max-width: 825px;
      margin: auto!important;;
      @media screen and (max-width: 991px) {
        max-width: 384px;
      }
    }
    .modal-content {
      border-radius: 0;
      border: 0;
      background-color: #F6F6F6!important;
    }
    .modal-body {
      height: 463px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @media (max-width: 991px) {
        padding: 50px 20px;
        height: 463px;
      }
    }
  }
  .modal-changedata {
    &-itens {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: space-between;
      &-close {
        position: absolute;
        right: -45px;
        top: -40px;
        width: 83px;
        height: 83px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: black;
        border: 1px solid black;
        border-radius: 50%;
        transition: 500ms;
        @media (max-width: 991px) {
          top: 20px;
          right: 20px;
          width: 40px;
          height: 40px;
          svg {
            max-width: 15px;
          }
        }
        &:hover,
        &:focus {
          opacity: 0.6;
        }
      }
    }
    &-content{
        max-height: auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        gap: 20px;
        padding: 0 30px;
        form{
            width: 100%;
            .row{
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-direction: row;
                @media screen and (max-width: 991px) {
                    flex-direction: column;
                }
                .col-md-6{
                    @media screen and (max-width: 991px) {
                        flex: 0 0 100%;
                        max-width: 100%;
                    }
                }
                input{
                    width: 100%;
                    height: 50px;
                    border: none;
                    background-color: var(--white);
                    border: 1px solid #B8B8B8;
                    text-align: center;
                    border-radius: 5px;
                    padding: 0 20px;
                    margin-bottom: 20px;
                    font-size: 18px;
                    font-family: "Font Regular";
                    color: #B8B8B8;
                    &::placeholder{
                        font-size: 18px;
                        font-family: "Font Regular";
                        color: var(--black);
                    }
                }
            }
        }
    }
  }
.content-input-check {
    display: flex;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    gap: 30px;
    .form-check {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 0;
    }
    input[type="checkbox"]:checked:before {
        content: "";
        height: 100%;
        width: 100%;
        background: url("~@/assets/img/icons/check.png");
        background-position: center !important;
        background-repeat: no-repeat !important;
        background-color: var(--white);
    }
    input[type="checkbox"]:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: var(--white);
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 15px;
        border: 0;
    }
    input[type="checkbox"] {
        position: relative;
        height: 30px;
        width: 30px;
        border-radius: 15px;
        border: 1px solid #173F35;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        outline: 0 !important;
        margin-right: 20px;
    }
    label {
        font-size: 12px;
        font-family: "Font Regular";
        color: black;
        width: calc(100% - 50px);
        text-align: left;
        padding-top: 2px;
        margin-bottom: 0;
        a {
            color: black;
            text-decoration: underline !important;;
            font-size: 12px;
            font-family: "Font Regular";
            cursor: pointer;
        }
    }
}
.content-input-button{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    button{
        width: 280px;
        height: 56px;
        border: none;
        background: rgb(254,206,9);
        background: linear-gradient(90deg, rgba(254,206,9,1) 0%, rgba(245,137,31,1) 100%);
        text-align: center;
        border-radius: 10px;
        padding: 0 20px;
        margin-bottom: 20px;
        font-size: 18px;
        font-family: "Font Regular";
        color: black;
        transition: 500ms;
        text-transform: uppercase;
    }
}
  </style>